// API wrapper component
// Provides methods from api-provider as props on child component.

import React from 'react'
import PropTypes from 'prop-types'

const api = (ComponentToWrap) => {
  return class ApiComponent extends React.Component {
    static contextTypes = {
      apiInstance: PropTypes.func.isRequired,
    }

    render() {
      const {apiInstance} = this.context
      return <ComponentToWrap {...this.props} apiInstance={apiInstance} />
    }
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api.js